"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOpenEvent = void 0;
var _openProductInfoDialog = require("@ori-events/open-product-info-dialog");
var _presentationHooks = require("@ori/presentation-hooks");
var _tsUtils = require("@ori/ts-utils");
var _react = require("react");
var _mapEventsToData = require("../../utils/mapEventsToData");
const useOpenEvent = ({
  onOpen
}) => {
  const [eventData, setEventData] = (0, _react.useState)();
  const onOpenProductInfoDialog = (0, _react.useCallback)(({
    detail
  }) => {
    setEventData((0, _mapEventsToData.mapEventToData)(detail));
    onOpen();
  }, [onOpen]);
  const events = (0, _react.useMemo)(() => [{
    name: _openProductInfoDialog.Name,
    listener: onOpenProductInfoDialog
  }], [onOpenProductInfoDialog]);
  (0, _presentationHooks.useGlobalEvents)(events);
  return (0, _react.useMemo)(() => {
    const {
      droppingId,
      subscriptionId,
      productCodes,
      ...otherData
    } = eventData ?? {};
    return {
      ...otherData,
      productCodes: productCodes ?? [],
      replaceSubscription: (0, _tsUtils.isNonNullable)(droppingId) && (0, _tsUtils.isNonNullable)(subscriptionId) ? {
        droppingId,
        subscriptionId
      } : undefined
    };
  }, [eventData]);
};
exports.useOpenEvent = useOpenEvent;